import React, { FC } from 'react';
import { TableCell, TableHead, TableRow } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';

interface IProps {
  hasActions: boolean;
}

const useStyles = makeStyles(theme => ({
  actionsCell: {
    padding: `${theme.spacing(2)}px ${theme.spacing()}px`,
  },
  avatarCell: {
    padding: `${theme.spacing(2)}px 12px ${theme.spacing(2)}px 0`,
  },
}));

const TableHeader: FC<IProps> = ({ hasActions }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <TableHead>
      <TableRow>
        {hasActions && <TableCell className={classes.actionsCell} />}
        <TableCell className={hasActions && classes.avatarCell} colSpan={2}>
          {t('common:name')}
        </TableCell>
        <TableCell>{t('common:role')}</TableCell>
        <TableCell>{t('common:title')}</TableCell>
        <TableCell>{t('common:department')}</TableCell>
        <TableCell>{t('common:location')}</TableCell>
      </TableRow>
    </TableHead>
  );
};

export default TableHeader;
